// extracted by mini-css-extract-plugin
export default {"popup_wrap":"createRestriction_popup_wrap__GbcDD","popup_message":"createRestriction_popup_message__vprc8","popup_message_button":"createRestriction_popup_message_button__ikclz"};